import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SeoHead — Reusable SEO meta component
 * Usage: <SeoHead title="Rooms" description="..." canonical="/rooms" />
 */
const SITE_NAME = "Ocean Paradise Hotel & Resort - Cheap Hotel in Ocean Shores WA";
const BASE_URL = "https://www.oceanparadisehotel.us";
const DEFAULT_IMAGE = `${BASE_URL}/og-image.jpg`;

function SeoHead({
  title,
  description = "Ocean Paradise Hotel & Resort is an affordable beachfront hotel in Ocean Shores WA located at 773 Ocean Shores Blvd NW near beach access, Chance A La Mer State Park, and Ocean Shores Convention Center.",
  canonical = "/",
  image = DEFAULT_IMAGE,
  imageAlt = "Ocean Paradise Hotel & Resort beachfront view in Ocean Shores WA",
  type = "website",
  noIndex = false,
  jsonLd = null,
}) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : "Cheap Hotel in Ocean Shores WA | Ocean Paradise Beachfront Hotel";

  const fullCanonical = `${BASE_URL}${canonical}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>

      <meta name="description" content={description} />

      <meta
        name="keywords"
        content="Ocean Shores hotel, Cheap hotel in Ocean Shores WA, Hotel in Ocean Shores WA, Ocean Shores beach hotel, Oceanfront hotel Ocean Shores, Beachfront hotel in Ocean Shores, Hotel near Ocean Shores beach, Ocean Shores resort, Affordable hotel in Ocean Shores WA, Family friendly hotel Ocean Shores, Pet friendly hotel Ocean Shores, Ocean view hotel Ocean Shores, Hotel near Ocean Shores Convention Center, Hotel with indoor pool Ocean Shores, Free WiFi hotel Ocean Shores, 773 Ocean Shores Blvd NW hotel"
      />

      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={fullCanonical} />

      <meta name="geo.region" content="US-WA" />
      <meta name="geo.placename" content="773 Ocean Shores Blvd NW, Ocean Shores, WA 98569" />
      <meta name="geo.position" content="46.9741;-124.1565" />
      <meta name="ICBM" content="46.9741, -124.1565" />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}

export default SeoHead;
